<template><svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26 0H0V19.3333H5.2V27L14.625 19.3333H26V0ZM24.05 17.3333H13.975L7.15 22.8567V17.337H1.95V2.00367H24.05V17.3333Z" fill="#0B3459"/>
</svg></template><script>export default {}</script>
